import { CopyButton } from './components';
import { StyledTextField } from './CopyTextField.styled';

type Props = {
  value: string;
};

export const CopyTextField = ({ value }: Props) => (
  <StyledTextField value={value} fullWidth InputProps={{ readOnly: true }} suffix={<CopyButton value={value} />} />
);
